export default "__VITE_ASSET__BsQsnEte__"